define.alias("ember-math-helpers/helpers/clz32", "preview-grid/helpers/clz32");